export const normalizeString = (value?: string | null): string => (
    (value ?? '').trim().toLowerCase()
);
